import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';

export const getSalesOrderStatusType = (status) => {
    if (status === 'win' || status === 'lost') return status;
    if (!status || typeof status !== 'object') return '';

    if (getBackendBoolean(status.isWin ?? status.win)) return 'win';
    if (getBackendBoolean(status.isLost ?? status.lost)) return 'lost';
    if (!getBackendBoolean(status.blnendstate)) return '';

    if (String(status.intendstatetype) === '1') return 'win';
    if (String(status.intendstatetype) === '0') return 'lost';
    return '';
};

export const getSalesOrderCloseDateFields = ({
    currentCloseDate,
    now = () => new Date(),
    status,
}) => {
    if (currentCloseDate || !getSalesOrderStatusType(status)) return {};
    return { closeDate: now() };
};
